/*
 * product-custom-purchase-mist.js
 * Modeled on product-custom-purchase-rosehip.js.
 *
 * Single pack option (1-Pack / 2-Pack visible; hidden 3/6/12-Pack back the
 * 3-month subscription and Buy Once pack grid).
 *
 * Base price = bottles × $35 (Mist 2oz bottle).
 * Discount % = (base - actual) / base × 100, rounded.
 */

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney =
  window.Shopify.formatMoney ||
  function (cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const amount = cents / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

// Round-trip-safe formatter: drop the decimals on whole-dollar amounts (e.g.
// "$35") but keep them when there are non-zero cents (e.g. "$34.50"). Mist
// has half-dollar selling plan prices that would otherwise round and mislead.
const formatMistPrice = (cents) => {
  let value = cents;
  if (typeof value === "string") value = value.replace(".", "");
  value = Number(value) || 0;
  const hasCents = value % 100 !== 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).format(value / 100);
};

document.addEventListener("DOMContentLoaded", () => {
  const FREE_SHIPPING_THRESHOLD_CENTS = 10000;
  const DEFAULT_SHIPPING_TEXT = "$6.95 Shipping";
  // Mist runs a single pack track (1-Pack); the top selector is removed.
  // The pack grid (1/2/3-Pack) is always visible inside Buy Once.
  const DEFAULT_PACK = "1-Pack";

  // Per-measure base price per bottle (cents). Mist has a measure dimension
  // (Choose Offer) that changes the per-bottle base used for "Save X%" math.
  const BASE_PRICE_PER_BOTTLE_BY_MEASURE_CENTS = {
    "Rose Mist 2oz": 3500,
    "4 Fills 8oz": 6200,
    "Rose Mist Set 10oz": 9700,
  };
  const FALLBACK_BASE_PRICE_PER_BOTTLE_CENTS = 3500;

  // Read dynamic selling plan data injected by Liquid
  let sellingPlansData = {};
  const spScript = document.getElementById("mist-selling-plans");
  if (spScript) {
    try {
      sellingPlansData = JSON.parse(spScript.textContent);
    } catch (e) {
      console.warn("Could not parse mist selling plans", e);
    }
  }

  // Read hardcoded plan ID map injected by Liquid. Shape is
  // { [measure]: { [packLabel]: { first, threeMonth, showThreeMonth,
  //   perDelivery, heading, interval } } } — measure-keyed because Mist ships
  // distinct selling plans + card layouts per Choose Offer measure. `first` is
  // the top card's plan (monthly for 2oz, the 2-month plan for 4 Fills / Set).
  let planMap = {};
  const pmScript = document.getElementById("mist-plan-map");
  if (pmScript) {
    try {
      planMap = JSON.parse(pmScript.textContent);
    } catch (e) {
      console.warn("Could not parse mist plan map", e);
    }
  }

  const getPackPlans = (packValue) => {
    if (!packValue) return null;
    const measureKey = selectedMeasure || Object.keys(planMap)[0];
    const byPack = measureKey ? planMap[measureKey] : null;
    return byPack ? byPack[packValue] || null : null;
  };

  const parsePackBottles = (packValue) => {
    if (!packValue) return 0;
    const m = String(packValue).match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  };

  const packLabelFromBottles = (bottles) => `${bottles}-Pack`;

  const getBasePricePerBottle = (measure) => {
    if (measure && BASE_PRICE_PER_BOTTLE_BY_MEASURE_CENTS[measure] != null) {
      return BASE_PRICE_PER_BOTTLE_BY_MEASURE_CENTS[measure];
    }
    return FALLBACK_BASE_PRICE_PER_BOTTLE_CENTS;
  };

  const getFormulaBasePrice = (packValue, measure) =>
    parsePackBottles(packValue) * getBasePricePerBottle(measure);

  // Measure-aware unit label. Reads selectedMeasure from closure scope so all
  // existing call sites stay the same.
  const bottlesLabel = (n) => {
    if (selectedMeasure === "4 Fills 8oz") {
      return n === 1 ? "4 fills" : `${n}x 4 fills`;
    }
    if (selectedMeasure === "Rose Mist Set 10oz") {
      return n === 1 ? "Rose Mist + 4 fills" : `${n} sets`;
    }
    return n === 1 ? "1 bottle" : `${n} bottles`;
  };

  // DOM references
  const productForm = document.querySelector(".product-single__form");
  if (!productForm) return;

  const formContainer =
    productForm.closest('[data-section-type="product-template"]') ||
    productForm.closest("[data-product-container]");
  const sectionId = formContainer ? formContainer.dataset.sectionId : null;
  const productJSONScript = formContainer
    ? formContainer.querySelector(`#ProductJson-${sectionId}`)
    : document.querySelector(
        'script[type="application/json"][data-product-json]',
      );

  const productData = productJSONScript
    ? JSON.parse(productJSONScript.textContent)
    : window.customProductData;

  const productContainer = document.querySelector(
    ".custom-subscription-widget-container.mist-widget",
  );
  const subscriptionIdInput = productForm.querySelector(
    'input[name="selling_plan"]',
  );
  const variantIdInput = productForm.querySelector('[name="id"]');

  const btnTextElement = document.querySelector(".btn--add-to-cart .btn__text");
  const shippingPriceElement = document.querySelector(
    "#buy-once-option .shipping-price",
  );

  // Mist's top pack selector is gone — only Choose Offer (measure) remains as
  // a customer-facing option, and it can live on option1 OR option2 depending
  // on Shopify's option order. Anything that doesn't look like a pack value is
  // treated as the measure radio set.
  const radiosLookLikePacks = (nodeList) =>
    nodeList.length > 0 &&
    [...nodeList].some((r) => /\d+\s*-?\s*Pack/i.test(r.value || ""));

  const option1Radios = productForm.querySelectorAll('input[name="option1"]');
  const option2Radios = productForm.querySelectorAll('input[name="option2"]');

  let measureRadios;
  if (option1Radios.length && !radiosLookLikePacks(option1Radios)) {
    measureRadios = option1Radios;
  } else if (option2Radios.length && !radiosLookLikePacks(option2Radios)) {
    measureRadios = option2Radios;
  } else {
    measureRadios = [];
  }

  const purchaseRadios = productContainer
    ? productContainer.querySelectorAll('input[name="purchase_option"]')
    : [];

  let selectedPack = DEFAULT_PACK;
  let selectedBuyOncePack = DEFAULT_PACK;
  let selectedMeasure = "";

  const packButtons = productContainer
    ? productContainer.querySelectorAll(".pack-button")
    : [];
  const packGrid = productContainer
    ? productContainer.querySelector("[data-pack-selector]")
    : null;
  const threeMonthLabel = productContainer
    ? productContainer.querySelector(".purchase-option-label--three-month")
    : null;

  // --- CORE FUNCTIONS ---

  // Does this option value look like a pack value (e.g., "6-Pack", "6 Pack",
  // bare "6")? Used to avoid colliding with measure values like "Rose Mist 2oz"
  // whose embedded digit would falsely match a pack count.
  const looksLikePack = (opt) =>
    opt != null && /^\s*\d+\s*(-?\s*pack)?\s*$/i.test(String(opt));

  // Match a variant by pack value, optionally filtered by the selected
  // measure. Mist variants are 2D (measure × pack), so we prefer variants
  // that match BOTH dimensions, then fall back to pack-only matching.
  const variantMatchesMeasure = (variant, measure) => {
    if (!measure) return true;
    return variant.option1 === measure || variant.option2 === measure;
  };

  const getVariantByPack = (packValue, measure) => {
    if (!productData || !packValue) return null;
    const lower = String(packValue).toLowerCase();
    const targetBottles = parsePackBottles(packValue);
    const packOptionMatches = (opt) => {
      if (!opt) return false;
      if (opt === packValue) return true;
      if (opt.toLowerCase() === lower) return true;
      // Only treat the option as a pack match if it actually looks like a
      // pack value — prevents "Rose Mist 2oz" from masquerading as "2-Pack".
      return looksLikePack(opt) && parsePackBottles(opt) === targetBottles;
    };
    const allMatches = productData.variants.filter(
      (v) =>
        packOptionMatches(v.option1) ||
        packOptionMatches(v.option2) ||
        packOptionMatches(v.option3),
    );
    if (allMatches.length === 0) return null;
    return (
      allMatches.find((v) => variantMatchesMeasure(v, measure)) ||
      allMatches[0]
    );
  };

  const getSellingPlanByPlanId = (variantId, planId) => {
    const vData = sellingPlansData[variantId];
    if (!vData || !vData.allocations) return null;
    return vData.allocations.find((a) => a.plan_id === planId) || null;
  };

  const getTargetData = (isSubscription, packValue, planId) => {
    let price = 0;
    let compareAt = 0;
    let sellingPlan = "";

    const targetVariant = getVariantByPack(packValue, selectedMeasure);
    if (!targetVariant)
      return { variant: null, price: 0, compareAt: 0, sellingPlan: "" };

    const formulaBase = getFormulaBasePrice(packValue, selectedMeasure);

    if (isSubscription) {
      // Only honor the explicitly-specified plan ID. Never fall back to
      // another plan attached to the variant — that's how we used to leak
      // prices from unrelated selling plans.
      const allocation = planId
        ? getSellingPlanByPlanId(targetVariant.id, planId)
        : null;
      if (allocation && allocation.price > 0) {
        sellingPlan = allocation.plan_id;
        price = allocation.price;
      } else {
        price = targetVariant.price;
      }
      compareAt = formulaBase;
    } else {
      price = targetVariant.price;
      compareAt = formulaBase;
    }

    return {
      variant: targetVariant,
      price: price,
      compareAt: compareAt,
      sellingPlan: sellingPlan.toString(),
    };
  };

  const updateBuyOnceLinkPrice = () => {
    const el = document.querySelector(".js-buy-once-link-price");
    if (!el || !selectedPack) return;
    const vd = getTargetData(false, selectedPack, null);
    if (vd.variant) {
      el.textContent = formatMistPrice(vd.price);
    }
  };

  // --- PACK GRID LOGIC ---

  // The pack grid (1/2/3-Pack) is always present inside Buy Once now, so we
  // simply return whichever pill the customer last clicked.
  const getEffectiveBuyOncePack = () =>
    selectedBuyOncePack || DEFAULT_PACK;

  const updatePackGridVisibility = () => {
    if (!packGrid) return;
    packGrid.classList.add("is-visible");
    packGrid.style.display = "flex";
  };

  // Refresh every "Save X%" pill rendered in the pack grid.
  const updatePackBadges = () => {
    document
      .querySelectorAll(".pack-save-badge[data-pack-save-badge]")
      .forEach((badge) => {
        const packValue = badge.dataset.packSaveBadge;
        const variant = getVariantByPack(packValue, selectedMeasure);
        if (!variant) {
          badge.textContent = "";
          return;
        }
        const base = getFormulaBasePrice(packValue, selectedMeasure);
        const price = variant.price;
        if (base > price && base > 0) {
          const pct = Math.ceil(((base - price) / base) * 100);
          badge.textContent = "Save " + pct + "%";
        } else {
          badge.textContent = "";
        }
      });
  };

  // 3-month card is always Most Popular in the single-pack mist flow.
  const updateMostPopularBanner = () => {
    if (!threeMonthLabel) return;
    threeMonthLabel.classList.add("is-most-popular");
  };

  const updateBuyOnceCountLabel = () => {
    const el = document.querySelector(".js-buy-once-count");
    if (!el) return;
    el.textContent = bottlesLabel(parsePackBottles(getEffectiveBuyOncePack()));
  };

  const updateSubscriptionDeliveryLabels = () => {
    const monthlyEl = document.querySelector(".js-monthly-bottles-display");
    if (monthlyEl) {
      monthlyEl.textContent = bottlesLabel(parsePackBottles(selectedPack));
    }
    const threeMonthEl = document.querySelector(
      ".js-three-month-bottles-display",
    );
    if (threeMonthEl) {
      const monthlyBottles = parsePackBottles(selectedPack);
      threeMonthEl.textContent = bottlesLabel(monthlyBottles * 3);
    }
  };

  // Monthly free-shipping line toggles based on the monthly plan price for the
  // currently selected top pack. Threshold matches the Buy Once one ($100).
  const updateMonthlyFreeShipping = () => {
    const el = document.querySelector(".js-monthly-free-shipping");
    if (!el) return;
    const packPlans = getPackPlans(selectedPack);
    const monthlyPlanId = packPlans ? packPlans.first : null;
    const data = getTargetData(true, selectedPack, monthlyPlanId);
    const showFree =
      data.variant && data.price >= FREE_SHIPPING_THRESHOLD_CENTS;
    el.style.display = showFree ? "" : "none";
  };

  // 3-month free-shipping line — same threshold ($100). The 3-month plan
  // ships a 3× pack, so we look up the multiplied pack variant.
  const updateThreeMonthFreeShipping = () => {
    const el = document.querySelector(".js-three-month-free-shipping");
    if (!el) return;
    const packPlans = getPackPlans(selectedPack);
    const threeMonthPlanId = packPlans ? packPlans.threeMonth : null;
    const threeMonthPack = packLabelFromBottles(
      parsePackBottles(selectedPack) * 3,
    );
    const data = getTargetData(true, threeMonthPack, threeMonthPlanId);
    const showFree =
      data.variant && data.price >= FREE_SHIPPING_THRESHOLD_CENTS;
    el.style.display = showFree ? "" : "none";
  };

  // Reconfigure the subscription cards for the active measure. 2oz keeps the
  // Monthly + 3-Month pair; 4 Fills and Set collapse to a single card whose
  // heading/cadence come from the plan map and whose 3-Month sibling is hidden.
  // Runs on init and on every measure switch (no page reload between measures).
  const applyMeasureLayout = () => {
    if (!productContainer) return;
    const packPlans = getPackPlans(selectedPack);
    if (!packPlans) return;

    const headingEl = productContainer.querySelector(".js-first-card-heading");
    if (headingEl && packPlans.heading) headingEl.textContent = packPlans.heading;
    const intervalEl = productContainer.querySelector(".js-first-card-interval");
    if (intervalEl && packPlans.interval)
      intervalEl.textContent = packPlans.interval;

    // Show/hide the 3-Month card. Use '' (not 'block') so the stylesheet's
    // display rule wins when the card is shown.
    if (threeMonthLabel) {
      threeMonthLabel.style.display = packPlans.showThreeMonth ? "" : "none";
    }

    // If the 3-Month card is hidden while still checked (e.g. it was selected
    // before switching measures), fall back to the first card so a visible
    // option stays selected. Set .checked directly — no change event, no
    // recursion back into updateFormAndPrices.
    if (!packPlans.showThreeMonth) {
      const threeMonthRadio = productContainer.querySelector(
        "#purchase-option-3month",
      );
      const firstRadio = productContainer.querySelector(
        "#purchase-option-monthly",
      );
      if (threeMonthRadio && threeMonthRadio.checked && firstRadio) {
        firstRadio.checked = true;
        purchaseRadios.forEach((r) =>
          r.closest("label").classList.remove("is-selected"),
        );
        firstRadio.closest("label").classList.add("is-selected");
      }
    }
  };

  // --- MAIN UPDATE ---
  const updateFormAndPrices = () => {
    if (!productContainer || !selectedPack) return;
    applyMeasureLayout();
    const selectedRadio = productContainer.querySelector(
      'input[name="purchase_option"]:checked',
    );
    if (!selectedRadio) return;

    const purchaseOptionValue = selectedRadio.value;
    const isSubscription = purchaseOptionValue !== "onetime";
    const countMultiplier =
      parseInt(selectedRadio.dataset.countMultiplier, 10) || 1;

    let effectivePack;
    if (!isSubscription) {
      effectivePack = getEffectiveBuyOncePack();
    } else if (countMultiplier > 1) {
      effectivePack = packLabelFromBottles(
        parsePackBottles(selectedPack) * countMultiplier,
      );
    } else {
      effectivePack = selectedPack;
    }

    let activePlanId = null;
    if (isSubscription) {
      const packPlans = getPackPlans(selectedPack);
      if (packPlans) {
        activePlanId =
          countMultiplier > 1 ? packPlans.threeMonth : packPlans.first;
      }
    }

    const finalData = getTargetData(isSubscription, effectivePack, activePlanId);

    if (finalData.variant) {
      if (variantIdInput) {
        variantIdInput.value = finalData.variant.id;
        variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      if (subscriptionIdInput) {
        subscriptionIdInput.value = finalData.sellingPlan;
      }
    }

    updateAllPurchaseOptionPrices();
    updatePackGridVisibility();
    updatePackBadges();
    updateMostPopularBanner();
    updateBuyOnceCountLabel();
    updateSubscriptionDeliveryLabels();
    updateMonthlyFreeShipping();
    updateThreeMonthFreeShipping();

    if (btnTextElement && finalData.variant) {
      btnTextElement.textContent = finalData.variant.available
        ? "ADD TO CART"
        : "SOLD OUT";
    }

    updateBuyOnceLinkPrice();

    if (shippingPriceElement && purchaseOptionValue === "onetime") {
      if (finalData.price >= FREE_SHIPPING_THRESHOLD_CENTS) {
        shippingPriceElement.textContent = "Free Shipping";
        shippingPriceElement.style.fontWeight = "bold";
      } else {
        shippingPriceElement.textContent = DEFAULT_SHIPPING_TEXT;
        shippingPriceElement.style.fontWeight = "normal";
      }
    }

    // Keep selling plan IDs on every radio fresh for the current top pack.
    const packPlans = getPackPlans(selectedPack);
    productContainer
      .querySelectorAll('input[name="purchase_option"]')
      .forEach((radio) => {
        if (radio.value === "onetime") return;
        const mult = parseInt(radio.dataset.countMultiplier, 10) || 1;
        const radioPack =
          mult > 1
            ? packLabelFromBottles(parsePackBottles(selectedPack) * mult)
            : selectedPack;
        const radioVariant = getVariantByPack(radioPack, selectedMeasure);
        if (!radioVariant) return;
        const targetPlanId = packPlans
          ? mult > 1
            ? packPlans.threeMonth
            : packPlans.first
          : null;
        const allocation = targetPlanId
          ? getSellingPlanByPlanId(radioVariant.id, targetPlanId)
          : null;
        if (allocation) {
          radio.dataset.sellingPlanId = allocation.plan_id;
          radio.value = "subscription-" + allocation.plan_id;
        }
      });
  };

  const updateAllPurchaseOptionPrices = () => {
    const effectiveBuyOncePack = getEffectiveBuyOncePack();
    const buyOnceLabel = document.querySelector("#buy-once-option");
    if (buyOnceLabel) {
      const data = getTargetData(false, effectiveBuyOncePack, null);
      if (data.variant) {
        const formulaBase = getFormulaBasePrice(
          effectiveBuyOncePack,
          selectedMeasure,
        );
        fillPriceDetails(buyOnceLabel, data.price, data.compareAt, formulaBase, 1);
      }
    }

    if (!productContainer) return;
    const packPlans = getPackPlans(selectedPack);
    productContainer
      .querySelectorAll(".purchase-option-label:not(.purchase-option-onetime)")
      .forEach((label) => {
        const radioInput = label.querySelector('input[name="purchase_option"]');
        const mult = radioInput
          ? parseInt(radioInput.dataset.countMultiplier, 10) || 1
          : 1;
        const subPack =
          mult > 1
            ? packLabelFromBottles(parsePackBottles(selectedPack) * mult)
            : selectedPack;
        const targetPlanId = packPlans
          ? mult > 1
            ? packPlans.threeMonth
            : packPlans.first
          : null;
        const data = getTargetData(true, subPack, targetPlanId);
        if (data.variant) {
          const formulaBase = getFormulaBasePrice(subPack, selectedMeasure);
          // The first card (mult === 1) bills per delivery for measures that
          // opt in (4 Fills / Set); the 3-Month card always shows "/mo".
          const perDelivery = mult === 1 && !!(packPlans && packPlans.perDelivery);
          fillPriceDetails(
            label,
            data.price,
            data.compareAt,
            formulaBase,
            mult,
            perDelivery,
          );
        }
      });
  };

  // Subscription boxes default to PER MONTH: the plan total divided by the
  // number of months it covers (Monthly = 1, 3-Month Delivery = 3), suffixed
  // "/mo". The strikethrough base is divided the same way so the "Save X%"
  // badge — computed from the undivided figures — stays unchanged. When
  // `perDelivery` is set (the 2-Month card on 4 Fills / Set) we instead show the
  // full per-shipment charge with no division and no "/mo" suffix; the cadence
  // is carried by the "every 2 months" line beneath it.
  const PER_MONTH_SUFFIX =
    ' / <span style="font-weight:500;font-size:0.8em;">mo</span>';

  const fillPriceDetails = (
    label,
    price,
    compare,
    formulaBase,
    months,
    perDelivery,
  ) => {
    const pDisplay = label.querySelector(".current-price-display");
    const cDisplay = label.querySelector(".compare-at-price-display");
    const sLabel = label.querySelector(".savings-label");
    const base = formulaBase || compare;

    if (label.classList.contains("purchase-option-onetime")) {
      if (pDisplay) pDisplay.textContent = formatMistPrice(price);
      if (cDisplay) {
        if (base > price) {
          cDisplay.textContent = formatMistPrice(base);
          cDisplay.style.display = "inline";
          cDisplay.style.visibility = "visible";
        } else {
          cDisplay.style.display = "none";
          cDisplay.style.visibility = "hidden";
        }
      }
      if (sLabel) sLabel.style.display = "none";
      return;
    }

    const divisor = perDelivery ? 1 : months && months > 1 ? months : 1;
    const perMonthPrice = Math.round(price / divisor);
    const perMonthBase = Math.round(base / divisor);

    if (pDisplay) {
      pDisplay.innerHTML = perDelivery
        ? formatMistPrice(perMonthPrice)
        : formatMistPrice(perMonthPrice) + PER_MONTH_SUFFIX;
    }
    if (cDisplay) {
      if (base > price) {
        cDisplay.textContent = formatMistPrice(perMonthBase);
        cDisplay.style.display = "inline";
        cDisplay.style.visibility = "visible";
      } else {
        cDisplay.style.display = "none";
        cDisplay.style.visibility = "hidden";
      }
    }
    if (sLabel) {
      if (base > price && base > 0) {
        const pct = Math.ceil(((base - price) / base) * 100);
        sLabel.textContent = `Save ${pct}%`;
        sLabel.style.display = "inline-block";
      } else {
        sLabel.style.display = "none";
      }
    }
  };

  const handlePurchaseOptionChange = (e) => {
    const selectedRadio = e.target;

    purchaseRadios.forEach((radio) => {
      radio.closest("label").classList.remove("is-selected");
    });
    selectedRadio.closest("label").classList.add("is-selected");

    if (selectedRadio.value === "onetime") {
      const buyOnceBox = document.getElementById("buy-once-option");
      if (buyOnceBox) {
        buyOnceBox.style.display = "block";
      }
    }

    updateFormAndPrices();
  };

  // --- LISTENERS ---

  packButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      packButtons.forEach((btn) => btn.classList.remove("is-selected-pack"));
      button.classList.add("is-selected-pack");
      selectedBuyOncePack = button.dataset.packValue;
      updateBuyOnceCountLabel();
      updateFormAndPrices();
    });
  });

  // Measure radios ("Choose Offer"). When the customer picks a different
  // measure, refresh everything so variants and base price align.
  measureRadios.forEach((radio) => {
    if (radio.checked) {
      selectedMeasure = radio.value;
    }
    radio.addEventListener("change", (e) => {
      selectedMeasure = e.target.value;
      setTimeout(updateFormAndPrices, 50);
    });
  });

  purchaseRadios.forEach((radio) => {
    radio.addEventListener("change", handlePurchaseOptionChange);
  });

  // --- INIT ---
  const initialMeasureRadio =
    [...measureRadios].find((r) => r.checked) || null;
  if (initialMeasureRadio) {
    selectedMeasure = initialMeasureRadio.value;
  }

  const checkedRadio = document.querySelector(
    'input[name="purchase_option"]:checked',
  );
  if (checkedRadio) {
    setTimeout(() => checkedRadio.dispatchEvent(new Event("change")), 100);
  } else {
    updateFormAndPrices();
  }
});
